exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-distributors-table[data-v-6c0c7116] {\n    min-height: 200px;\n    max-height: 400px;\n}\n", ""]);

// exports
